export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_DATA_OVERRIDE = "LOGIN_DATA_OVERRIDE";



export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_FAILURE = "FORGET_PASSWORD_FAILURE";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILURE = "GET_PROFILE_FAILURE";

export const UPDATE_PROFILE_DATA = "UPDATE_PROFILE_DATA";
export const UPDATE_PROFILE_DATA_SUCCESS = "UPDATE_PROFILE_DATA_SUCCESS";
export const UPDATE_PROFILE_DATA_FAILURE = "UPDATE_PROFILE_DATA_FAILURE";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

export const GET_USER_MANAGEMENT = "GET_USER_MANAGEMENT";
export const GET_USER_MANAGEMENT_SUCCESS = "GET_USER_MANAGEMENT_SUCCESS";
export const GET_USER_MANAGEMENT_FAILURE = "GET_USER_MANAGEMENT_FAILURE";

export const SHOW_USER_MANAGEMENT = "SHOW_USER_MANAGEMENT";
export const SHOW_USER_MANAGEMENT_SUCCESS = "SHOW_USER_MANAGEMENT_SUCCESS";
export const SHOW_USER_MANAGEMENT_FAILURE = "SHOW_USER_MANAGEMENT_FAILURE";

export const UPDATE_USER_MANAGEMENT = "UPDATE_USER_MANAGEMENT";
export const UPDATE_USER_MANAGEMENT_SUCCESS = "UPDATE_USER_MANAGEMENT_SUCCESS";
export const UPDATE_USER_MANAGEMENT_FAILURE = "UPDATE_USER_MANAGEMENT_FAILURE";

export const GET_CMS = "GET_CMS";
export const GET_CMS_SUCCESS = "GET_CMS_SUCCESS";
export const GET_CMS_FAILURE = "GET_CMS_FAILURE";

export const UPDATE_CMS = "UPDATE_CMS";
export const UPDATE_CMS_SUCCESS = "UPDATE_CMS_SUCCESS";
export const UPDATE_CMS_FAILURE = "UPDATE_CMS_FAILURE";

export const SHOW_CMS = "SHOW_CMS";
export const SHOW_CMS_SUCCESS = "SHOW_CMS_SUCCESS";
export const SHOW_CMS_FAILURE = "SHOW_CMS_FAILURE";

export const GET_SETTINGS = "GET_SETTINGS";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";
export const GET_SETTINGS_FAILURE = "GET_SETTINGS_FAILURE";

export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const UPDATE_SETTINGS_SUCCESS = "UPDATE_SETTINGS_SUCCESS";
export const UPDATE_SETTINGS_FAILURE = "UPDATE_SETTINGS_FAILURE";

export const GET_DASHBOARD = "GET_DASHBOARD";
export const GET_DASHBOARD_SUCCESS = "GET_DASHBOARD_SUCCESS";
export const GET_DASHBOARD_FAILURE = "GET_DASHBOARD_FAILURE";

export const CREATE_CATEGORY = "CREATE_CATEGORY";
export const CREATE_CATEGORY_SUCCESS = "CREATE_CATEGORY_SUCCESS";
export const CREATE_CATEGORY_FAILURE = "CREATE_CATEGORY_FAILURE";

export const PARENT_CATEGORY_LIST = "PARENT_CATEGORY_LIST";
export const PARENT_CATEGORY_LIST_SUCCESS = "PARENT_CATEGORY_LIST_SUCCESS";
export const PARENT_CATEGORY_LIST_FAILURE = "PARENT_CATEGORY_LIST_FAILURE";

export const SUB_CATEGORY_LIST = "SUB_CATEGORY_LIST";
export const SUB_CATEGORY_LIST_SUCCESS = "SUB_CATEGORY_LIST_SUCCESS";
export const SUB_CATEGORY_LIST_FAILURE = "SUB_CATEGORY_LIST_FAILURE";


export const PARENT_CATEGORY_BY_CHILD = "PARENT_CATEGORY_BY_CHILD";
export const PARENT_CATEGORY_BY_CHILD_SUCCESS = "PARENT_CATEGORY_BY_CHILD_SUCCESS";
export const PARENT_CATEGORY_BY_CHILD_FAILURE = "PARENT_CATEGORY_BY_CHILD_FAILURE";

export const CHILD_CATEGORY_LIST = "CHILD_CATEGORY_LIST";
export const CHILD_CATEGORY_LIST_SUCCESS = "CHILD_CATEGORY_LIST_SUCCESS";
export const CHILD_CATEGORY_LIST_FAILURE = "CHILD_CATEGORY_LIST_FAILURE";

export const GET_CATEGORY_LIST = "GET_CATEGORY_LIST";
export const GET_CATEGORY_LIST_SUCCESS = "GET_CATEGORY_LIST_SUCCESS";
export const GET_CATEGORY_LIST_FAILURE = "GET_CATEGORY_LIST_FAILURE";

export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS";
export const UPDATE_CATEGORY_FAILURE = "UPDATE_CATEGORY_FAILURE";

export const VIEW_CATEGORY = "VIEW_CATEGORY";
export const VIEW_CATEGORY_SUCCESS = "VIEW_CATEGORY_SUCCESS";
export const VIEW_CATEGORY_FAILURE = "VIEW_CATEGORY_FAILURE";

export const UPDATE_STATUS_CATEGORY = "UPDATE_STATUS_CATEGORY";
export const UPDATE_STATUS_CATEGORY_SUCCESS = "UPDATE_STATUS_CATEGORY_SUCCESS";
export const UPDATE_STATUS_CATEGORY_FAILURE = "UPDATE_STATUS_CATEGORY_FAILURE";

export const CREATE_CURRICULUM = "CREATE_CURRICULUM";
export const CREATE_CURRICULUM_SUCCESS = "CREATE_CURRICULUM_SUCCESS";
export const CREATE_CURRICULUM_FAILURE = "CREATE_CURRICULUM_FAILURE";

export const UPDATE_CURRICULUM = "UPDATE_CURRICULUM";
export const UPDATE_CURRICULUM_SUCCESS = "UPDATE_CURRICULUM_SUCCESS";
export const UPDATE_CURRICULUM_FAILURE = "UPDATE_CURRICULUM_FAILURE";

export const VIEW_CURRICULUM = "VIEW_CURRICULUM";
export const VIEW_CURRICULUM_SUCCESS = "VIEW_CURRICULUM_SUCCESS";
export const VIEW_CURRICULUM_FAILURE = "VIEW_CURRICULUM_FAILURE";

export const GET_CURRICULUM_LIST = "GET_CURRICULUM_LIST";
export const GET_CURRICULUM_LIST_SUCCESS = "GET_CURRICULUM_LIST_SUCCESS";
export const GET_CURRICULUM_LIST_FAILURE = "GET_CURRICULUM_LIST_FAILURE";

export const UPDATE_STATUS_CURRICULUM = "UPDATE_STATUS_CURRICULUM";
export const UPDATE_STATUS_CURRICULUM_SUCCESS =
  "UPDATE_STATUS_CURRICULUM_SUCCESS";
export const UPDATE_STATUS_CURRICULUM_FAILURE =
  "UPDATE_STATUS_CURRICULUM_FAILURE";

export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";
export const GET_PRODUCT_LIST_SUCCESS = "GET_PRODUCT_LIST_SUCCESS";
export const GET_PRODUCT_LIST_FAILURE = "GET_PRODUCT_LIST_FAILURE";

export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAILURE = "CREATE_PRODUCT_FAILURE";

export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAILURE = "UPDATE_PRODUCT_FAILURE";

export const VIEW_PRODUCT = "VIEW_PRODUCT";
export const VIEW_PRODUCT_SUCCESS = "VIEW_PRODUCT_SUCCESS";
export const VIEW_PRODUCT_FAILURE = "VIEW_PRODUCT_FAILURE";

export const UPDATE_STATUS_PRODUCT = "UPDATE_STATUS_PRODUCT";
export const UPDATE_STATUS_PRODUCT_SUCCESS = "UPDATE_STATUS_PRODUCT_SUCCESS";
export const UPDATE_STATUS_PRODUCT_FAILURE = "UPDATE_STATUS_PRODUCT_FAILURE";

export const GET_MAIN_MODULE_LIST = "GET_MAIN_MODULE_LIST";
export const GET_MAIN_MODULE_LIST_SUCCESS = "GET_MAIN_MODULE_LIST_SUCCESS";
export const GET_MAIN_MODULE_LIST_FAILURE = "GET_MAIN_MODULE_LIST_FAILURE";

export const CREATE_MAIN_MODULE = "CREATE_MAIN_MODULE";
export const CREATE_MAIN_MODULE_SUCCESS = "CREATE_MAIN_MODULE_SUCCESS";
export const CREATE_MAIN_MODULE_FAILURE = "CREATE_MAIN_MODULE_FAILURE";

export const UPDATE_MAIN_MODULE = "UPDATE_MAIN_MODULE";
export const UPDATE_MAIN_MODULE_SUCCESS = "UPDATE_MAIN_MODULE_SUCCESS";
export const UPDATE_MAIN_MODULE_FAILURE = "UPDATE_MAIN_MODULE_FAILURE";

export const VIEW_MAIN_MODULE = "VIEW_MAIN_MODULE";
export const VIEW_MAIN_MODULE_SUCCESS = "VIEW_MAIN_MODULE_SUCCESS";
export const VIEW_MAIN_MODULE_FAILURE = "VIEW_MAIN_MODULE_FAILURE";

export const UPDATE_STATUS_MAIN_MODULE = "UPDATE_STATUS_MAIN_MODULE";
export const UPDATE_STATUS_MAIN_MODULE_SUCCESS =
  "UPDATE_STATUS_MAIN_MODULE_SUCCESS";
export const UPDATE_STATUS_MAIN_MODULE_FAILURE =
  "UPDATE_STATUS_MAIN_MODULE_FAILURE";

export const GET_SCHOOL_LIST = "GET_SCHOOL_LIST";
export const GET_SCHOOL_LIST_SUCCESS = "GET_SCHOOL_LIST_SUCCESS";
export const GET_SCHOOL_LIST_FAILURE = "GET_SCHOOL_LIST_FAILURE";

export const CREATE_SCHOOL = "CREATE_SCHOOL";
export const CREATE_SCHOOL_SUCCESS = "CREATE_SCHOOL_SUCCESS";
export const CREATE_SCHOOL_FAILURE = "CREATE_SCHOOL_FAILURE";

export const UPDATE_STATUS_SCHOOL = "UPDATE_STATUS_SCHOOL";
export const UPDATE_STATUS_SCHOOL_SUCCESS = "UPDATE_STATUS_SCHOOL_SUCCESS";
export const UPDATE_STATUS_SCHOOL_FAILURE = "UPDATE_STATUS_SCHOOL_FAILURE";

export const VIEW_SCHOOL = "VIEW_SCHOOL";
export const VIEW_SCHOOL_SUCCESS = "VIEW_SCHOOL_SUCCESS";
export const VIEW_SCHOOL_FAILURE = "VIEW_SCHOOL_FAILURE";

export const GET_TEACHER_LIST = "GET_TEACHER_LIST";
export const GET_TEACHER_LIST_SUCCESS = "GET_TEACHER_LIST_SUCCESS";
export const GET_TEACHER_LIST_FAILURE = "GET_TEACHER_LIST_FAILURE";

export const CREATE_TEACHER = "CREATE_TEACHER";
export const CREATE_TEACHER_SUCCESS = "CREATE_TEACHER_SUCCESS";
export const CREATE_TEACHER_FAILURE = "CREATE_TEACHER_FAILURE";

export const DELETE_TEACHER = "DELETE_TEACHER";
export const DELETE_TEACHER_SUCCESS = "DELETE_TEACHER_SUCCESS";
export const DELETE_TEACHER_FAILURE = "DELETE_TEACHER_FAILURE";

export const VIEW_TEACHER = "VIEW_TEACHER";
export const VIEW_TEACHER_SUCCESS = "VIEW_TEACHER_SUCCESS";
export const VIEW_TEACHER_FAILURE = "VIEW_TEACHER_FAILURE";

export const UPDATE_TEACHER = "UPDATE_TEACHER";
export const UPDATE_TEACHER_SUCCESS = "UPDATE_TEACHER_SUCCESS";
export const UPDATE_TEACHER_FAILURE = "UPDATE_TEACHER_FAILURE";

export const UPDATE_STATUS_TEACHER = "UPDATE_STATUS_TEACHER";
export const UPDATE_STATUS_TEACHER_SUCCESS = "UPDATE_STATUS_TEACHER_SUCCESS";
export const UPDATE_STATUS_TEACHER_FAILURE = "UPDATE_STATUS_TEACHER_FAILURE";

export const GET_STUDENT_LIST = "GET_STUDENT_LIST";
export const GET_STUDENT_LIST_SUCCESS = "GET_STUDENT_LIST_SUCCESS";
export const GET_STUDENT_LIST_FAILURE = "GET_STUDENT_LIST_FAILURE";

export const VIEW_STUDENT = "VIEW_STUDENT";
export const VIEW_STUDENT_SUCCESS = "VIEW_STUDENT_SUCCESS";
export const VIEW_STUDENT_FAILURE = "VIEW_STUDENT_FAILure";

export const EXPORT_STUDENT = "EXPORT_STUDENT";
export const EXPORT_STUDENT_SUCCESS = "EXPORT_STUDENT_SUCCESS";
export const EXPORT_STUDENT_FAILURE = "EXPORT_STUDENT_FAILURE";

export const EXPORT_SCHOOL = "EXPORT_SCHOOL";
export const EXPORT_SCHOOL_SUCCESS = "EXPORT_SCHOOL_SUCCESS";
export const EXPORT_SCHOOL_FAILURE = "EXPORT_SCHOOL_FAILURE";

export const EXPORT_TEACHER = "EXPORT_TEACHER";
export const EXPORT_TEACHER_SUCCESS = "EXPORT_TEACHER_SUCCESS";
export const EXPORT_TEACHER_FAILURE = "EXPORT_TEACHER_FAILURE";
export const RELOAD_SCHOOL_DETAIL = "RELOAD_SCHOOL_DETAIL";

export const RENEWABLE_LESSON_LIST = "RENEWABLE_LESSON_LIST";
export const RENEWABLE_LESSON_LIST_SUCCESS = "RENEWABLE_LESSON_LIST_SUCCESS";
export const RENEWABLE_LESSON_LIST_FAILURE = "RENEWABLE_LESSON_LIST_FAILURE";

export const RENEWABLE_LESSON_TYPE_LIST = "RENEWABLE_LESSON_TYPE_LIST";
export const RENEWABLE_LESSON_TYPE_LIST_SUCCESS =
  "RENEWABLE_LESSON_TYPE_LIST_SUCCESS";
export const RENEWABLE_LESSON_TYPE_LIST_FAILURE =
  "RENEWABLE_LESSON_TYPE_LIST_FAILURE";

export const RENEWABLE_LESSON_ADD_TYPE = "RENEWABLE_LESSON_ADD_TYPE";
export const RENEWABLE_LESSON_ADD_TYPE_SUCCESS =
  "RENEWABLE_LESSON_ADD_TYPE_SUCCESS";
export const RENEWABLE_LESSON_ADD_TYPE_FAILURE =
  "RENEWABLE_LESSON_ADD_TYPE_FAILURE";

export const RENEWABLE_LESSON_ADD_SUB_TYPE = "RENEWABLE_LESSON_ADD_SUB_TYPE";
export const RENEWABLE_LESSON_ADD_SUB_TYPE_SUCCESS =
  "RENEWABLE_LESSON_ADD_SUB_TYPE_SUCCESS";
export const RENEWABLE_LESSON_ADD_SUB_TYPE_FAILURE =
  "RENEWABLE_LESSON_ADD_SUB_TYPE_FAILURE";

export const RENEWABLE_LESSON_SUBMIT = "RENEWABLE_LESSON_SUBMIT";
export const RENEWABLE_LESSON_SUBMIT_SUCCESS =
  "RENEWABLE_LESSON_SUBMIT_SUCCESS";
export const RENEWABLE_LESSON_SUBMIT_FAILURE =
  "RENEWABLE_LESSON_SUBMIT_FAILURE";

export const GET_VIEW_LESSON = "GET_VIEW_LESSON";
export const GET_VIEW_LESSON_SUCCESS = "GET_VIEW_LESSON_SUCCESS";
export const GET_VIEW_LESSON_FAILURE = "GET_VIEW_LESSON_FAILURE";

export const EDIT_LESSON = "EDIT_LESSON";
export const EDIT_LESSON_SUCCESS = "EDIT_LESSON_SUCCESS";
export const EDIT_LESSON_FAILURE = "EDIT_LESSON_FAILURE";

export const GET_VIEW_SUB_LESSON = "GET_VIEW_SUB_LESSON";
export const GET_VIEW_SUB_LESSON_SUCCESS = "GET_VIEW_SUB_LESSON_SUCCESS";
export const GET_VIEW_SUB_LESSON_FAILURE = "GET_VIEW_SUB_LESSON_FAILURE";

export const EDIT_SUB_LESSON = "EDIT_SUB_LESSON";
export const EDIT_SUB_LESSON_SUCCESS = "EDIT_SUB_LESSON_SUCCESS";
export const EDIT_SUB_LESSON_FAILURE = "EDIT_SUB_LESSON_FAILURE";

export const UPDATE_LESSION_STATUS = "UPDATE_LESSION_STATUS";
export const UPDATE_LESSION_STATUS_SUCCESS = "UPDATE_LESSION_STATUS_SUCCESS";
export const UPDATE_LESSION_STATUS_FAILURE = "UPDATE_LESSION_STATUS_FAILURE";

export const UPDATE_SUB_LESSION_STATUS = "UPDATE_SUB_LESSION_STATUS";
export const UPDATE_SUB_LESSION_STATUS_SUCCESS =
  "UPDATE_SUB_LESSION_STATUS_SUCCESS";
export const UPDATE_SUB_LESSION_STATUS_FAILURE =
  "UPDATE_SUB_LESSION_STATUS_FAILURE";

export const GET_PARENT_SUB_CATEGORY_PRODUCT =
  "GET_PARENT_SUB_CATEGORY_PRODUCT";
export const GET_PARENT_SUB_CATEGORY_PRODUCT_SUCCESS =
  "GET_PARENT_SUB_CATEGORY_PRODUCT_SUCCESS";
export const GET_PARENT_SUB_CATEGORY_PRODUCT_FAILURE =
  "GET_PARENT_SUB_CATEGORY_PRODUCT_FAILURE";

export const GET_CODE_LISTING_MANAGEMENT = "GET_CODE_LISTING_MANAGEMENT";
export const GET_CODE_LISTING_MANAGEMENT_SUCCESS =
  "GET_CODE_LISTING_MANAGEMENT_SUCCESS";
export const GET_CODE_LISTING_MANAGEMENT_FAILURE =
  "GET_CODE_LISTING_MANAGEMENT_FAILURE";

export const GET_SCHOOLNAME_FILTER = "GET_SCHOOLNAME_FILTER";
export const GET_SCHOOLNAME_FILTER_SUCCESS = "GET_SCHOOLNAME_FILTER_SUCCESS";
export const GET_SCHOOLNAME_FILTER_FAILURE = "GET_SCHOOLNAME_FILTER_FAILURE";

export const GET_CURRICULUM_HEADING = "GET_CURRICULUM_HEADING";
export const GET_CURRICULUM_HEADING_SUCCESS = "GET_CURRICULUM_HEADING_SUCCESS";
export const GET_CURRICULUM_HEADING_FAILURE = "GET_CURRICULUM_HEADING_FAILURE";

export const VIEW_SCHOOL_DETAILES = "VIEW_SCHOOL_DETAILES";
export const VIEW_SCHOOL_DETAILES_SUCCESS = "VIEW_SCHOOL_DETAILES_SUCCESS";
export const VIEW_SCHOOL_DETAILES_FAILURE = "VIEW_SCHOOL_DETAILES_FAILURE";

export const EDIT_SCHOOL = "EDIT_SCHOOL";
export const EDIT_SCHOOL_SUCCESS = "EDIT_SCHOOL_SUCCESS";
export const EDIT_SCHOOL_FAILURE = "EDIT_SCHOOL_FAILURE";

export const GET_ACTIVE_CURRICULUM_LIST = "GET_ACTIVE_CURRICULUM_LIST";
export const GET_ACTIVE_CURRICULUM_LIST_SUCCESS =
  "GET_ACTIVE_CURRICULUM_LIST_SUCCESS";

export const GET_ACTIVE_CURRICULUM_LIST_FAILURE =
  "GET_ACTIVE_CURRICULUM_LIST_FAILURE";

export const VIEW_SCHOOL_STATES = "VIEW_SCHOOL_STATES";
export const VIEW_SCHOOL_STATES_SUCCESS = " VIEW_SCHOOL_STATES_SUCCESS";
export const VIEW_SCHOOL_STATES_FAILURE = "VIEW_SCHOOL_STATES_FAILURE"

export const GET_COUNTRY_LIST = "GET_COUNTRY_LIST";
export const GET_COUNTRY_LIST_SUCCESS = "GET_COUNTRY_LIST_SUCCESS";
export const GET_COUNTRY_LIST_FAILURE= "GET_COUNTRY_LIST_FAILURE";

export const GET_STATE_LIST_SUCCESS = "GET_STATE_LIST_SUCCESS";
export const GET_STATE_LIST_FAILURE = "GET_STATE_LIST_FAILURE";
export const GET_STATE_LIST= "GET_STATE_LIST";

export const GET_HEADING_LIST_SUCCESS = "GET_HEADING_LIST_SUCCESS";
export const GET_HEADING_LIST_FAILURE = "GET_HEADING_LIST_FAILURE";
export const GET_HEADING_LIST= "GET_HEADING_LIST";

export const CREATE_HEADING_FAILURE = "CREATE_HEADING_FAILURE";
export const CREATE_HEADING_SUCCESS = "CREATE_HEADING_SUCCESS";
export const CREATE_HEADING= "CREATE_HEADING";
 
export const VIEW_HEADING_SUCCESS = "VIEW_HEADING_SUCCESS";
export const VIEW_HEADING_FAILURE = "VIEW_HEADING_FAILURE";
export const VIEW_HEADING= "VIEW_HEADING";
 
export const UPDATE_HEADING = "UPDATE_HEADING";
export const UPDATE_HEADING_SUCCESS = "UPDATE_HEADING_SUCCESS";
export const UPDATE_HEADING_FAILURE = "UPDATE_HEADING_FAILURE";

export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE";

export const GET_CITY_LIST = "GET_CITY_LIST";
export const GET_CITY_LIST_SUCCESS = "GET_CITY_LIST_SUCCESS";
export const GET_CITY_LIST_FAILURE = "GET_CITY_LIST_FAILURE";

export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAILURE = "GET_CATEGORIES_FAILURE";

export const CHANGE_HEADING_STATUS = "CHANGE_HEADING_STATUS";
export const CHANGE_HEADING_STATUS_SUCCESS = "CHANGE_HEADING_STATUS_SUCCESS";
export const CHANGE_HEADING_STATUS_FAILURE = "CHANGE_HEADING_STATUS_FAILURE";
 
export const GLB_FILE = "GLB_FILE";
export const GLB_FILE_SUCCESS = "GLB_FILE_SUCCESS";
export const GLB_FILE_FAILURE = "GLB_FILE_FAILURE";

export const JSON_FILE = "JSON_FILE";
export const JSON_FILE_SUCCESS = "JSON_FILE_SUCCESS";
export const JSON_FILE_FAILURE = "JSON_FILE_FAILURE";

export const VIEW_JSON_FILE = "VIEW_JSON_FILE";
export const VIEW_JSON_FILE_SUCCESS = "VIEW_JSON_FILE_SUCCESS";
export const VIEW_JSON_FILE_FAILURE = "VIEW_JSON_FILE_FAILURE";



export const GET_MODULES = "GET_MODULES";
export const GET_MODULES_SUCCESS = "GET_MODULES_SUCCESS";
export const GET_MODULES_FAILURE = "GET_MODULES_FAILURE";

export const CREATE_MODULES = "CREATE_MODULES";
export const CREATE_MODULES_SUCCESS = "CREATE_MODULES_SUCCESS";
export const CREATE_MODULES_FAILURE = "CREATE_MODULES_FAILURE";

export const SHOW_MODULES = "SHOW_MODULES";
export const SHOW_MODULES_SUCCESS = "SHOW_MODULES_SUCCESS";
export const SHOW_MODULES_FAILURE = "SHOW_MODULES_FAILURE";

export const UPDATE_MODULES = "UPDATE_MODULES";
export const UPDATE_MODULES_SUCCESS = "UPDATE_MODULES_SUCCESS";
export const UPDATE_MODULES_FAILURE = "UPDATE_MODULES_FAILURE";


export const GET_MODULE_LIST = "GET_MODULE_LIST";
export const GET_MODULE_LIST_FAILURE = "GET_MODULE_LIST_FAILURE";
export const GET_MODULE_LIST_SUCCESS = "GET_MODULE_LIST_SUCCESS";


export const CREATE_PERMISSION = "CREATE_PERMISSION";
export const CREATE_PERMISSION_SUCCESS = "CREATE_PERMISSION_SUCCESS";
export const CREATE_PERMISSION_FAILURE = "CREATE_PERMISSION_FAILURE";

export const UPDATE_PERMISSION = "UPDATE_PERMISSION";
export const UPDATE_PERMISSION_SUCCESS = "UPDATE_PERMISSION_SUCCESS";
export const UPDATE_PERMISSION_FAILURE = "UPDATE_PERMISSION_FAILURE";

export const GET_SUBADMIN = "GET_SUBADMIN";
export const GET_SUBADMIN_SUCCESS = "GET_SUBADMIN_SUCCESS";
export const GET_SUBADMIN_FAILURE = "GET_SUBADMIN_FAILURE";

export const UPDATE_SUBADMIN = "UPDATE_SUBADMIN";
export const UPDATE_SUBADMIN_SUCCESS = "UPDATE_SUBADMIN_SUCCESS";
export const UPDATE_SUBADMIN_FAILURE = "UPDATE_SUBADMIN_FAILURE";

export const VIEW_SUBADMIN = "VIEW_SUBADMIN";
export const VIEW_SUBADMIN_SUCCESS = "VIEW_SUBADMIN_SUCCESS";
export const VIEW_SUBADMIN_FAILURE = "VIEW_SUBADMIN_FAILURE";


export const DELETE_PARTICULAR_PRODUCT = "DELETE_PARTICULAR_PRODUCT";
export const DELETE_PARTICULAR_PRODUCT_SUCCESS = "DELETE_PARTICULAR_PRODUCT_SUCCESS";
export const DELETE_PARTICULAR_PRODUCT_FAILURE = "DELETE_PARTICULAR_PRODUCT_FAILURE";